export { default } from './GenericNewCarTile';
